import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

const StyledPagination = ({ pages, page, size, total, methodCustom, viewPaginations, opts, token, listTable, id, setLoading, paginationDiv, paginationClass }) => {

  const [pageNumbers, setPageNumbers] = useState([]);

  useEffect(() => {
    const startPage = Math.max(1, opts.page - Math.floor(viewPaginations / 2));
    const endPage = Math.min(pages, startPage + viewPaginations - 1);
    const newPages = createArray(startPage, endPage);
    setPageNumbers(newPages);
  }, [opts.page, pages, viewPaginations]);

  const createArray = (start, end) => {
    let result = [];
    for (let i = start; i <= end; i++) {
      result.push(i);
    }
    return result;
  };

  const handlePageChange = (number) => {
    opts.page = number;
    setLoading(true);
    id ? withId(number) : withoutId(number);
  };

  const withId = (number) => {
    methodCustom(token, id, opts)
      .then((response) => {
        listTable(response);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - methodCustom - ", error);
      });
  };

  const withoutId = (number) => {
    methodCustom(token, opts)
      .then((response) => {
        listTable(response.items);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error - methodCustom - ", error);
      });
  };

  const handlePrevPage = () => {
    if (opts.page > 1)
      handlePageChange(opts.page - 1);
  };

  const handleNextPage = () => {
    if (opts.page < pages)
      handlePageChange(opts.page + 1);
  };

  return (
    <div className={paginationDiv}>
      <ul className={paginationClass}>
        <li className={`page-item ${opts.page === 1 ? "disabled" : ""}`}>
          <Link className="page-link" to="#" onClick={handlePrevPage}>
            <i className="mdi mdi-chevron-left"></i>
          </Link>
        </li>
        {pageNumbers.map((number) => (
          <li
            key={number}
            className={`page-item ${opts.page === number ? "active" : ""}`}
          >
            <Link
              className="page-link"
              to="#"
              onClick={() => handlePageChange(number)}
            >
              {number}
            </Link>
          </li>
        ))}
        <li className={`page-item ${opts.page >= pages ? "disabled" : ""}`}>
          <Link className="page-link" to="#" onClick={handleNextPage}>
            <i className="mdi mdi-chevron-right"></i>
          </Link>
        </li>
      </ul>
    </div>
  );
};

StyledPagination.propTypes = {
  pages: PropTypes.number,
  viewPaginations: PropTypes.number,
  page: PropTypes.number,
  size: PropTypes.number,
  methodCustom: PropTypes.func,
  token: PropTypes.object,
  listTable: PropTypes.func,
  setLoading: PropTypes.func,
  opts: PropTypes.object,
  id: PropTypes.string,
  total: PropTypes.number,
  paginationDiv: PropTypes.string,
  paginationClass: PropTypes.string,
};

export default StyledPagination;
